
import { defineComponent } from 'vue'
import cms from '@/cms'

export default defineComponent({
  name: 'CmsSocialIcon',
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      required: true
    },
    rounded: {
      type: Boolean,
      default: true
    }
  },
  setup (props) {
    const iconSvg: string = cms.socialIcons.fa[props.icon]?.svg || ''
    if (!iconSvg) {
      console.warn(`Icon ${props.icon} was not found`)
    }

    return {
      iconName: props.icon,
      iconSvg,
      color: props.color,
      url: props.url,
      backgroundColor: props.backgroundColor,
      rounded: props.rounded
    }
  }
})
